<template>
  <div class="related-terms__wrapper">
    <p class="related-terms__title title">Related Terms</p>
    <ul class="related-terms__terms">
      <li
        v-for="term in relatedTerms"
        :key="term.Slug"
        class="related-terms__term"
      >
        <p class="related-terms__term-link-wrapper">
          <a-link
            :to="generateTermRoute(term)"
            class="related-terms__term-link term-link subtitle-3"
            >{{ term.Name }}
          </a-link>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import mixins from '@/utils/mixins'

export default {
  name: 'ARelatedTerms',
  mixins: [mixins.urlGenerators],
  props: {
    relatedTerms: propValidator([PROP_TYPES.ARRAY])
  }
}
</script>

<style lang="scss" scoped>
.related-terms__wrapper {
  .related-terms__title {
    margin-top: 40px;
    font-weight: 500;

    @include tablet {
      margin-top: 24px;
    }
  }

  .related-terms__term-link {
    margin-top: 40px;
    font-weight: 600;

    @include tablet {
      margin-top: 24px;
    }
  }

  .related-terms__terms {
    margin-bottom: 40px;

    @include tablet {
      margin-bottom: 24px;
    }
  }
}
</style>
